import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pipeline');
// @ts-ignore WIZ build 단계에서 Angular import가 실제 컴포넌트 코드로 변환됩니다.
import { OnInit } from '@angular/core';
// @ts-ignore WIZ build 단계에서 서비스 경로가 실제 src/libs 경로로 재작성됩니다.
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pipeline',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pipeline/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PagePipelineComponent implements OnInit {
    public prototypeInfo: any = null;
    public registry: any = null;
    public loadingInfo: boolean = true;
    public operationalStatus: any = null;
    public operationalStatusLoading: boolean = true;
    public operationalStatusError: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.loadOperationalStatus();
    }

    public async loadOperationalStatus() {
        this.operationalStatusLoading = true;
        this.loadingInfo = true;
        this.operationalStatusError = '';
        await this.service.render();
        try {
            const response = await fetch('/wiz/api/page.models/model_registry_snapshot');
            const payload = await response.json();
            const registry = payload?.data || payload;
            if (!response.ok || Number(payload?.code || response.status) !== 200 || registry?.available !== true || !Array.isArray(registry?.items)) {
                throw new Error(String(registry?.message || '모델 레지스트리를 불러오지 못했습니다.'));
            }
            this.registry = registry;
            this.operationalStatus = this.operationalStatusFromRegistry();
            this.prototypeInfo = this.prototypeInfoFromRegistry();
        } catch (error) {
            this.operationalStatusError = '운영 상태 연결을 확인해주세요.';
        }
        this.operationalStatusLoading = false;
        this.loadingInfo = false;
        await this.service.render();
    }

    private modelSampleCount(item: any): number {
        const summary = item?.summary || {};
        const values = [summary.training_samples, summary.n_windows, item?.metrics?.sample_count];
        for (const value of values) {
            const count = Number(value);
            if (Number.isFinite(count) && count >= 0) return count;
        }
        const distribution = summary.class_distribution || {};
        return Object.values(distribution).reduce((sum: number, value: any) => {
            const count = Number(value);
            return sum + (Number.isFinite(count) && count > 0 ? count : 0);
        }, 0);
    }

    private operationalStatusFromRegistry(): any {
        const dual = this.activeFamilyItem('rf-dual');
        const fall = this.activeFamilyItem('rf-fall-v2')?.model_id
            ? this.activeFamilyItem('rf-fall-v2')
            : this.activeFamilyItem('rf-pipeline');
        const posture = this.activeFamilyItem('xg-posture');
        const fallSamples = this.modelSampleCount(fall || dual);
        const postureSamples = this.modelSampleCount(posture);
        const dualReady = dual?.summary?.ready === true || dual?.active === true;
        const fallReady = fall?.summary?.ready === true || fall?.active === true;
        const postureReady = posture?.summary?.ready === true || posture?.active === true;
        const postureAlgorithm = String(posture?.summary?.active_algorithm || posture?.summary?.algorithm || posture?.metrics?.algorithm || '분류 모델');

        return {
            status: fallReady && postureReady ? 'ready' : 'model-required',
            analysis_engine_summary: {
                current_runtime: {
                    label: dualReady ? 'RF-Dual 운영 파이프라인' : (fallReady ? String(fall?.label || '낙상 모델') : '낙상 모델 연결 필요'),
                    note: fallReady && postureReady
                        ? `${String(fall?.label || '낙상 모델')} · ${String(posture?.label || 'XG-Posture')} 연결됨`
                        : '모델 관리에서 운영 모델 연결 상태를 확인해주세요.',
                },
            },
            dataset_summary: {
                fall_sample_count: fallSamples,
                fall_model_label: String(fall?.label || '낙상 모델'),
                fall_sample_note: fallReady ? `${String(fall?.label || '낙상 모델')} · 학습 요약 ${fallSamples.toLocaleString()}건` : '낙상 모델 연결 필요',
                fall_model_ready: fallReady,
                behavior_sample_count: postureSamples,
                behavior_model_label: String(posture?.label || 'XG-Posture'),
                behavior_sample_note: postureReady ? `${String(posture?.label || 'XG-Posture')} ${postureAlgorithm} · 학습 ${postureSamples.toLocaleString()}건` : '자세 모델 연결 필요',
                behavior_model_ready: postureReady,
            },
            realtime_candidate: {
                label: '최대 1.6초 Pose 창',
                note: '0.3초 간격 확인 · 정밀 분석 전 후보 전용',
            },
            updated_at: this.registry?.updated_at || '',
        };
    }

    private prototypeInfoFromRegistry(): any {
        const status = this.operationalStatus || {};
        const activeItems = this.registryItems().filter((item: any) => item?.active === true && !item?.missing);
        const modelTrainingStats = activeItems
            .map((item: any) => ({
                key: item.family,
                label: item.label || item.family,
                sample_count: this.modelSampleCount(item),
                algorithm: item?.metrics?.algorithm || item?.summary?.active_algorithm || item?.summary?.algorithm || '',
                accuracy: item?.metrics?.accuracy,
                f1: item?.metrics?.f1,
                macro_f1: item?.metrics?.macro_f1,
                precision: item?.metrics?.precision,
                recall: item?.metrics?.recall,
            }))
            .filter((item: any) => item.sample_count > 0);
        const fallReady = status?.dataset_summary?.fall_model_ready === true;
        const postureReady = status?.dataset_summary?.behavior_model_ready === true;

        return {
            model_registry: this.registry,
            dataset_summary: {
                ...(status.dataset_summary || {}),
                model_training_stats: modelTrainingStats,
                total_training_samples: modelTrainingStats.reduce((sum: number, item: any) => sum + item.sample_count, 0),
            },
            analysis_engine_summary: {
                ...(status.analysis_engine_summary || {}),
                layers: [
                    { title: '낙상 판단', status: fallReady ? 'ready' : 'training-needed', active_label: status?.dataset_summary?.fall_model_label || '연결 확인 필요' },
                    { title: '자세 분석', status: postureReady ? 'ready' : 'training-needed', active_label: status?.dataset_summary?.behavior_model_label || '연결 확인 필요' },
                    { title: '실시간 Pose', status: this.activeFamilyItem('pose-backbone')?.model_id ? 'ready' : 'training-needed', active_label: this.activeFamilyItem('pose-backbone')?.label || '연결 확인 필요' },
                ],
            },
            fall_decision_criteria: {
                bands: [
                    { key: 'candidate', label: '빠른 후보', description: '최근 Pose 창에서 낙상 가능 순간을 빠르게 표시합니다.' },
                    { key: 'review', label: '정밀 확인', description: '전체 사람 시계열과 움직임 근거를 다시 확인합니다.' },
                    { key: 'filtered', label: '오탐 필터', description: '정지 사물·사람 여부·가림 조건을 마지막으로 검사합니다.' },
                    { key: 'final', label: '최종 결과', description: '정밀 분석과 후처리를 통과한 결과를 확정합니다.' },
                ],
                rf_dual_reason: [
                    '낙상 모델은 움직임의 시간 흐름과 낙상 가능성을 계산합니다.',
                    'XG-Posture는 서기·걷기·달리기·앉기·눕기 상태를 설명합니다.',
                    '두 결과를 함께 사용해 눕기와 실제 낙상 후보를 구분합니다.',
                ],
            },
            realtime_readiness: {
                headline: '현재 운영 모델 레지스트리와 연결되어 실시간 후보 및 전체 영상 정밀 분석 상태를 함께 확인합니다.',
            },
            camera_transition_plan: [
                '브라우저 Pose로 최근 최대 1.6초 움직임 창을 구성합니다.',
                '0.3초 간격의 후보 결과를 전체 영상 정밀 분석으로 확정하거나 해제합니다.',
            ],
            analysis_diagnostics: {
                items: [
                    {
                        title: '운영 모델 레지스트리',
                        severity: fallReady && postureReady ? 'info' : 'warning',
                        description: fallReady && postureReady ? '낙상·자세 운영 모델과 학습 요약이 연결되어 있습니다.' : '일부 운영 모델 연결을 확인해야 합니다.',
                    },
                ],
            },
        };
    }

    public currentRuntimeStatus(): any {
        return this.operationalStatus?.analysis_engine_summary?.current_runtime
            || this.prototypeInfo?.analysis_engine_summary?.current_runtime
            || {};
    }

    private operationalDatasetSummary(): any {
        return this.operationalStatus?.dataset_summary
            || this.prototypeInfo?.dataset_summary
            || {};
    }

    public operationalSampleText(key: 'fall_sample_count' | 'behavior_sample_count'): string {
        const summary = this.operationalDatasetSummary();
        if (Object.prototype.hasOwnProperty.call(summary, key)) {
            const value = Number(summary[key]);
            if (Number.isFinite(value) && value >= 0) return `${value.toLocaleString()}건`;
        }
        return this.operationalStatusLoading ? '확인 중...' : '연결 확인 필요';
    }

    public operationalDatasetText(key: string): string {
        return String(this.operationalDatasetSummary()?.[key] || '').trim();
    }

    public realtimeCandidateStatus(): any {
        return this.operationalStatus?.realtime_candidate || {
            label: '최대 1.6초 Pose 창',
            note: '0.3초 간격 확인 · 정밀 분석 전 후보 전용',
        };
    }

    public isAdminUser() {
        return this.service.auth?.check?.role('admin') === true;
    }

    public statusBadgeClass(status: string) {
        switch (String(status || '').toLowerCase()) {
            case 'ready':
            case 'always-on':
            case 'ready-now':
            case 'hybrid-summary-runtime':
            case 'trained-yolo-runtime':
            case 'pass':
                return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
            case 'preview':
            case 'next':
            case 'phase-1-browser-streaming':
            case 'review':
                return 'bg-sky-50 text-sky-700 border border-sky-200';
            case 'fallback':
            case 'training-needed':
            case 'heuristic-fallback':
            case 'needs-review':
            case 'not-run':
                return 'bg-amber-50 text-amber-700 border border-amber-200';
            default:
                return 'bg-slate-100 text-slate-700 border border-slate-200';
        }
    }

    public diagnosticClass(severity: string) {
        switch (String(severity || '').toLowerCase()) {
            case 'warn':
            case 'warning':
                return 'bg-amber-50 text-amber-800 border border-amber-200';
            case 'error':
            case 'fail':
                return 'bg-rose-50 text-rose-800 border border-rose-200';
            default:
                return 'bg-slate-50 text-slate-700 border border-slate-200';
        }
    }

    public modelTrainingStats(): any[] {
        const stats = this.prototypeInfo?.dataset_summary?.model_training_stats;
        return Array.isArray(stats) ? stats : [];
    }

    public modelTrainingStat(key: string): any {
        return this.modelTrainingStats().find((item: any) => item?.key === key) || {};
    }

    public modelTrainingStatCards(): any[] {
        return this.modelTrainingStats().slice(0, 6);
    }

    public totalTrainingSamples(): number {
        const total = Number(this.prototypeInfo?.dataset_summary?.total_training_samples || 0);
        if (Number.isFinite(total) && total > 0) return total;
        return this.modelTrainingStats().reduce((sum: number, item: any) => sum + Number(item?.sample_count || 0), 0);
    }

    public percentText(value: any): string {
        const num = Number(value || 0);
        if (!Number.isFinite(num) || num <= 0) return '-';
        return `${(num * 100).toFixed(1)}%`;
    }

    public modelMetricText(item: any): string {
        const bits = [];
        if (item?.algorithm) bits.push(String(item.algorithm));
        const f1 = Number(item?.macro_f1 ?? item?.f1 ?? 0);
        const acc = Number(item?.accuracy ?? 0);
        const recall = Number(item?.recall ?? 0);
        const precision = Number(item?.precision ?? 0);
        if (Number.isFinite(f1) && f1 > 0) bits.push(`F1 ${(f1 * 100).toFixed(1)}%`);
        if (Number.isFinite(acc) && acc > 0) bits.push(`Acc ${(acc * 100).toFixed(1)}%`);
        if (Number.isFinite(recall) && recall > 0) bits.push(`Recall ${(recall * 100).toFixed(1)}%`);
        if (Number.isFinite(precision) && precision > 0) bits.push(`Precision ${(precision * 100).toFixed(1)}%`);
        return bits.join(' · ') || '-';
    }

    public pipelineFlowSteps(): any[] {
        return [
            {
                number: 1,
                tag: '입력',
                title: '웹캠이나 영상을 받습니다',
                description: '실시간 카메라와 업로드 영상을 같은 분석 화면에서 시작합니다.',
                technology: '실시간 웹캠 · 업로드 영상',
            },
            {
                number: 2,
                tag: '사람·자세',
                title: '사람과 관절 움직임을 찾습니다',
                description: '실시간은 브라우저에서 사람 관절을 바로 찾고, 전체 영상은 서버가 사람별 움직임을 다시 분석합니다.',
                technology: 'MediaPipe Pose · 서버 Pose 추적',
            },
            {
                number: 3,
                tag: '빠른 후보',
                title: '낙상 후보를 빠르게 찾습니다',
                description: '최근 1.6초 관절 흐름을 0.3초마다 확인해 급강하·기울기·낮아진 자세가 이어지는 순간을 후보로 표시합니다.',
                technology: `Fast Gate · ${this.fallDecisionModelCode()}`,
            },
            {
                number: 4,
                tag: '정밀 분석',
                title: '전체 흐름으로 다시 확인합니다',
                description: '전체 영상의 위치·관절·시간 변화 특징으로 낙상 확률과 자세를 계산해 빠른 후보를 확정하거나 해제합니다.',
                technology: `${this.fallDecisionModelCode()} · XG-Posture`,
            },
            {
                number: 5,
                tag: '상황 이해',
                title: '표정과 주변 환경을 함께 봅니다',
                description: '얼굴 표정과 침대·의자·바닥 매트 같은 주변 사물을 별도 모델로 확인해 상황 근거를 보탭니다.',
                technology: 'AI-Hub 82 표정 · YOLOE 환경 객체',
            },
            {
                number: 6,
                tag: '결과',
                title: '근거를 모아 최종 결과를 냅니다',
                description: '자세·환경·표정 위험도를 설정 비율로 합치고, 움직임과 사람/사물 필터를 통과한 결과를 보여줍니다.',
                technology: 'AI Weight Manager · 최종 필터',
            },
        ];
    }

    public trainingFlowSteps(): any[] {
        return [
            { number: 1, title: '데이터 수집', description: '낙상·비낙상 영상 확보' },
            { number: 2, title: '전처리', description: '프레임·사람 시계열 정리' },
            { number: 3, title: '라벨링', description: '낙상 여부와 자세 표시' },
            { number: 4, title: '모델 학습', description: '특징과 정답 관계 학습' },
            { number: 5, title: '검증·승격', description: '성능과 안전 조건 확인' },
        ];
    }

    private registryItems(): any[] {
        return Array.isArray(this.registry?.items) ? this.registry.items : [];
    }

    private modelFamily(item: any): string {
        return String(item?.family || '').trim();
    }

    private runtimeFallOverrideFamily(): string {
        const selection = this.registry?.runtime_selection || {};
        if (String(selection['rf-pipeline'] || '').trim()) return 'rf-pipeline';
        if (String(selection['rf-fall-v2'] || '').trim()) return 'rf-fall-v2';
        return '';
    }

    private activeFamilyItem(family: string): any {
        const rows = this.registryItems().filter((item: any) => this.modelFamily(item) === family && !item?.missing);
        return rows.find((item: any) => item?.source === 'active' && item?.active === true)
            || rows.find((item: any) => item?.source === 'active')
            || rows.find((item: any) => item?.source === 'custom-final')
            || rows[0]
            || {};
    }

    private activeFallDecisionItem(): any {
        const selection = this.registry?.runtime_selection || {};
        const selectedId = String(selection['rf-pipeline'] || selection['rf-fall-v2'] || '').trim();
        if (selectedId) {
            const selected = this.registryItems().find((item: any) => String(item?.model_id || '') === selectedId);
            if (selected) return selected;
        }
        const v2 = this.activeFamilyItem('rf-fall-v2');
        if (v2?.model_id) return v2;
        return this.activeFamilyItem('rf-pipeline');
    }

    private rfFallV2Item(): any {
        return this.activeFamilyItem('rf-fall-v2');
    }

    private rfPipelineItem(): any {
        return this.activeFamilyItem('rf-pipeline');
    }

    private isCompatibilityFallArtifact(item: any): boolean {
        const status = String(item?.summary?.operational_status || '').trim();
        return this.modelFamily(item) === 'rf-fall-v2' && status.startsWith('compatibility_artifact_active');
    }

    private eligibleRfFallCandidate(): any {
        const rows = this.registryItems().filter((item: any) => {
            const summary = item?.summary || {};
            return this.modelFamily(item) === 'rf-fall-v2'
                && String(item?.source || '').toLowerCase() === 'candidate'
                && (summary?.candidate_eligible === true || summary?.eligible === true);
        });
        return [...rows].sort((a: any, b: any) => {
            const bTime = Date.parse(String(b?.artifact_updated_at || b?.updated_at || b?.created_at || '')) || 0;
            const aTime = Date.parse(String(a?.artifact_updated_at || a?.updated_at || a?.created_at || '')) || 0;
            return bTime - aTime;
        })[0] || {};
    }

    public hasFallArtifactRisk(): boolean {
        return this.isCompatibilityFallArtifact(this.activeFallDecisionItem());
    }

    public fallArtifactRiskText(): string {
        return '현재 기본 RF-Fall v2는 원본 학습 파일 유실 뒤 만든 임시 호환 복구본입니다. 표시 중인 1,592건·F1 93.02%·Recall 95.40%는 과거 best-recorded 복구 메타데이터로, 현재 로드 바이너리의 재검증 성능이 아닙니다.';
    }

    public fallArtifactCandidateText(): string {
        const candidate = this.eligibleRfFallCandidate();
        if (!candidate?.model_id) {
            return '실데이터 재학습 후보를 같은 독립 holdout에서 현재 emergency repair와 직접 비교하고 명시 승격하기 전까지 구조적 위험이 남습니다.';
        }
        const summary = candidate?.summary || {};
        const validation = summary?.validation || {};
        const jobId = String(summary?.candidate_job_id || summary?.job_id || candidate?.label || '후보').trim();
        const samples = Number(summary?.training_samples || candidate?.metrics?.sample_count || 0);
        const groups = Number(summary?.group_count || 0);
        const f1 = Number(validation?.f1 ?? summary?.f1 ?? candidate?.metrics?.f1 ?? 0);
        const recall = Number(validation?.recall ?? summary?.recall ?? candidate?.metrics?.recall ?? 0);
        const bits = [
            jobId,
            samples > 0 ? `${samples.toLocaleString()}건` : '',
            groups > 0 ? `${groups.toLocaleString()}그룹` : '',
            f1 > 0 ? `F1 ${(f1 * 100).toFixed(2)}%` : '',
            recall > 0 ? `Recall ${(recall * 100).toFixed(2)}%` : '',
        ].filter(Boolean);
        return `실데이터 후보 ${bits.join(' · ')}가 명시 적용 대기 중입니다. 현재 평가는 모두 10초·검출 27개 이상 자료이며 두 운영 실패 반례와 짧은 청크가 포함되지 않았습니다. 같은 독립 holdout에서 현재 모델과 직접 비교하고 설치 각도·저조도·후처리 포함 E2E 검증 후 승격해야 합니다.`;
    }

    public fallDecisionModelCode(): string {
        return this.modelFamily(this.activeFallDecisionItem()) === 'rf-pipeline' ? 'RF-Pipeline' : 'RF-Fall v2';
    }

    private thresholdNumber(value: any, fallback: number): number {
        let raw = value;
        if (raw && typeof raw === 'object') {
            raw = raw.threshold ?? raw.value ?? raw.confirm ?? raw.score;
        }
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : fallback;
    }

    private thresholdWithSensitivity(value: number): number {
        const delta = Number(this.fallSensitivity()?.threshold_delta || 0);
        const adjusted = value + (Number.isFinite(delta) ? delta : 0);
        return Math.max(0.03, Math.min(0.99, adjusted));
    }

    private rfFallV2ThresholdValues(): any {
        const effective = this.fallSensitivity()?.effective_thresholds || {};
        const summaryThresholds = this.rfFallV2Item()?.summary?.thresholds || {};
        return {
            suspect: this.thresholdNumber(effective.suspect, this.thresholdWithSensitivity(this.thresholdNumber(summaryThresholds.suspect, 0.335))),
            confirm: this.thresholdNumber(effective.confirm, this.thresholdWithSensitivity(this.thresholdNumber(summaryThresholds.confirm, 0.455))),
            high: this.thresholdNumber(effective.high, this.thresholdWithSensitivity(this.thresholdNumber(summaryThresholds.high, 0.720))),
            bestF1: this.thresholdNumber(summaryThresholds.best_f1, 0.465),
        };
    }

    private rfPipelineThresholdValues(): any {
        const summary = this.rfPipelineItem()?.summary || {};
        const tuned = summary?.tuned_thresholds || {};
        const bestConfig = summary?.best_config || {};
        const baseConfirm = this.thresholdNumber(tuned.confirm ?? bestConfig.threshold, 0.465);
        const baseSuspect = this.thresholdNumber(tuned.suspect, Math.max(0.30, baseConfirm - 0.15));
        const baseHigh = this.thresholdNumber(tuned.high, Math.max(0.75, baseConfirm + 0.15));
        return {
            suspect: this.thresholdWithSensitivity(baseSuspect),
            confirm: this.thresholdWithSensitivity(baseConfirm),
            high: this.thresholdWithSensitivity(baseHigh),
        };
    }

    private activeFallThresholdValues(): any {
        return this.fallDecisionModelCode() === 'RF-Pipeline'
            ? this.rfPipelineThresholdValues()
            : this.rfFallV2ThresholdValues();
    }

    public fallSensitivity(): any {
        return this.registry?.fall_sensitivity || {};
    }

    public sensitivityLabel(): string {
        return String(this.fallSensitivity()?.label || '균형');
    }

    private thresholdPercent(value: any): string {
        const n = Number(value);
        return Number.isFinite(n) && n > 0 ? `${(n * 100).toFixed(1)}%` : '-';
    }

    public sensitivityThresholdText(): string {
        const thresholds = this.activeFallThresholdValues();
        return `${this.fallDecisionModelCode()} 기본 ${this.thresholdPercent(thresholds.confirm)} · 의심 ${this.thresholdPercent(thresholds.suspect)} · 상태 확정선 75.0%`;
    }

    public sensitivityDeltaText(): string {
        const delta = Number(this.fallSensitivity()?.threshold_delta || 0);
        if (!Number.isFinite(delta) || delta === 0) return '±0.0pp';
        return `${delta > 0 ? '+' : ''}${(delta * 100).toFixed(1)}pp`;
    }

    public fallRuntimePriorityText(): string {
        const current = this.fallDecisionModelCode();
        const override = this.runtimeFallOverrideFamily();
        const currentReason = override
            ? `모델 관리에서 ${current} 계열이 명시 선택되어 있습니다.`
            : (current === 'RF-Fall v2'
                ? 'RF-Pipeline 명시 선택이 없고 RF-Fall v2가 준비되어 있어 v2 확률을 최종 낙상 점수로 사용합니다.'
                : 'RF-Fall v2를 사용할 수 없어 RF-Pipeline 결과를 대체 경로로 사용합니다.');
        return `RF-Dual은 먼저 RF-Pipeline 13개 특성 결과를 계산합니다. RF-Fall v2가 준비되어 있고 RF-Pipeline을 명시 선택하지 않았으면 65개 특성의 v2 결과가 이를 대체합니다. F1 수치만 비교해 자동 전환하지 않습니다. ${currentReason}`;
    }

    public fallRuntimePriorityNote(): string {
        return 'RF-Pipeline과 RF-Fall v2의 F1은 데이터와 검증 조건이 달라 직접 우선순위 점수로 사용하지 않습니다.';
    }

    public fallDecisionCriteriaCards(): any[] {
        const thresholds = this.activeFallThresholdValues();
        const policy = this.registry?.occlusion_policy || {};
        const avgConf = this.thresholdPercent(this.thresholdNumber(policy.avg_conf_lt, 0.44));
        const lowerVisibility = this.thresholdPercent(this.thresholdNumber(policy.lower_body_visibility_lt, 0.48));
        const margin = this.thresholdPercent(this.thresholdNumber(policy.posture_margin_lt, 0.08));
        return [
            {
                label: '1. 사람 찾기',
                title: '한 사람의 시간 흐름을 만듭니다',
                body: '사람 위치 상자와 17개 관절점을 프레임마다 찾고, 같은 사람의 움직임이 어떻게 변했는지 이어 봅니다.',
                note: '실시간은 직전 청크 tail을 이어 붙이지만, 3프레임 gate는 현재 청크의 RF 검출 수를 기준으로 셉니다.',
            },
            {
                label: '2. 확률 계산',
                title: `${this.fallDecisionModelCode()} 기본 판정선 ${this.thresholdPercent(thresholds.confirm)}`,
                body: `현재 감도는 ${this.sensitivityLabel()} ${this.sensitivityDeltaText()}입니다. 의심선 ${this.thresholdPercent(thresholds.suspect)}는 급강하·기울기 같은 별도 움직임 근거가 함께 있을 때만 후보로 사용합니다.`,
                note: '판정선은 정확도가 아니라 모델 확률을 해석하는 경계입니다.',
            },
            {
                label: '3. 움직임 확인',
                title: 'RF 확률 직후 근거 수·움직임 gate를 적용합니다',
                body: '현재 RF 검출 프레임이 3개보다 적으면 낙상 false, 근거 부족, 점수 최대 10%로 억제합니다. 정지 상태·작은 하강량·낮아지지 않은 마지막 자세도 이 단계에서 확인합니다.',
                note: '여기서 조기 반환하지 않습니다. 자세·가림 보조와 두 사물 필터는 진단과 최종 후처리를 위해 계속 실행됩니다.',
            },
            {
                label: '4. 자세·가림 보조',
                title: 'XG-Posture는 설명과 보조 역할입니다',
                body: `서기·걷기·달리기·앉기·눕기를 설명합니다. 가림 보조는 bbox 평균 탐지 신뢰도 < ${avgConf}, 하체 가시성 < ${lowerVisibility}, 자세 확률 차이 < ${margin} 같은 조건에서만 후보로 켜집니다.`,
                note: '가림 보조가 켜져도 추가 점수와 자세 조건을 통과해야 실제 결과에 섞입니다.',
            },
            {
                label: '5. 최종 필터',
                title: '정지 사물과 사람 여부를 마지막에 확인합니다',
                body: '정지 사물 필터는 16프레임 이상 정지성 뒤 약한 관절점·비정상 골격을 보고, 별도 사람/사물 필터는 포즈·bbox 신뢰도·지속성과 희소·고정·가장자리 장비 규칙을 봅니다.',
                note: '두 모듈은 별개입니다. 골격 비율만으로 움직이는 후보를 차단하는 독립 hard veto는 아직 없습니다.',
            },
        ];
    }

    public fallThresholdRows(): any[] {
        const v2 = this.rfFallV2ThresholdValues();
        const pipeline = this.rfPipelineThresholdValues();
        return [
            { name: 'RF-Fall v2 suspect', value: this.thresholdPercent(v2.suspect), source: 'summary + 감도', meaning: '점수만으로 확정하지 않고 급강하·기울기·가림 같은 독립 근거와 함께 낙상 의심 후보로 사용' },
            { name: 'RF-Fall v2 confirm', value: this.thresholdPercent(v2.confirm), source: 'summary + 감도', meaning: '일반 업로드 전체 구간의 기본 초기 낙상 판정선' },
            { name: 'RF-Fall v2 best_f1', value: this.thresholdPercent(v2.bestF1), source: '검증 참고값', meaning: '검증 F1이 가장 높았던 지점이며 현재 런타임 판정선으로 자동 채택하지 않음' },
            { name: 'RF-Fall v2 high', value: this.thresholdPercent(v2.high), source: 'summary metadata', meaning: '저장된 high 참고값이며 현재 RF-Dual의 최종 상태 구분에는 직접 연결되지 않음' },
            { name: 'RF-Dual 상태 확정선', value: '75.0%', source: '현재 코드 경계', meaning: '낙상 확인·고위험 상태와 자세 보조의 차단 경계에 사용' },
            { name: 'RF-Pipeline 기본선', value: this.thresholdPercent(pipeline.confirm), source: '13개 특성 경로 + 감도', meaning: 'RF-Pipeline 명시 선택, 직접 요청 또는 RF-Fall v2 대체 경로에서 사용하는 기본 판정선' },
        ];
    }

    public fallAnalysisPathRows(): any[] {
        const v2 = this.rfFallV2ThresholdValues();
        return [
            {
                path: '실시간 화면 표시',
                model: 'MediaPipe Pose + 환경 전용 모델',
                threshold: '사람·관절은 브라우저에서 즉시, 환경 객체는 서버 보조 경로로 반복 갱신',
                note: '화면에 보이는 관절과 사물 표시는 빠른 피드백이며 그 자체가 최종 낙상 판정은 아닙니다.',
            },
            {
                path: '실시간 낙상 후보',
                model: this.fallDecisionModelCode(),
                threshold: '최근 최대 1.6초 Pose 창 · 0.3초 간격 · 연속 후보 확인',
                note: '빠른 경로는 candidate_only입니다. 낙상 순간을 놓치지 않기 위한 후보이며 최종 확정 권한은 없습니다.',
            },
            {
                path: '업로드 전체 정밀 분석',
                model: `${this.fallDecisionModelCode()} + XG-Posture`,
                threshold: `전체 사람 시계열 · 기본 확인선 ${this.thresholdPercent(v2.confirm)} · 움직임·가림 근거 확인`,
                note: '영상 전체를 다시 본 정밀 결과가 실시간 후보를 확정하거나 해제하고 최종 낙상 여부를 정합니다.',
            },
            {
                path: '상황 보조와 위험도 결합',
                model: '표정 + 환경 객체 + Agent Weight',
                threshold: 'Behavior · Environment · Emotion 비율 합계 100%',
                note: '사용자가 정한 비율로 보조 위험도를 합치되, 표정이나 사물 하나만으로 낙상을 확정하지 않습니다.',
            },
        ];
    }

    public fallSignalLayerRows(): any[] {
        return [
            {
                layer: '사람·관절 추적',
                input: 'MediaPipe Pose · 서버 Pose',
                rule: '사람 위치와 관절 움직임을 시간 순서로 연결',
                relation: '실시간 화면과 낙상·자세 모델이 공통으로 사용하는 움직임 자료를 만듭니다.',
            },
            {
                layer: '낙상·자세 분석',
                input: `${this.fallDecisionModelCode()} · XG-Posture`,
                rule: '시간에 따른 하강·기울기·자세 변화를 계산',
                relation: 'RF가 낙상 가능성을 만들고 XG-Posture가 서기·걷기·앉기·눕기 상태를 설명합니다.',
            },
            {
                layer: '표정 분석',
                input: 'AI-Hub 82 표정',
                rule: '얼굴 특징에서 현재 표정 상태를 보조 신호로 계산',
                relation: '자세 모델과 함께 실행되지만 표정 하나만으로 낙상을 판정하지 않습니다.',
            },
            {
                layer: '환경 객체 분석',
                input: 'YOLOE 환경 분할',
                rule: '침대·의자·바닥 매트 등 주변 사물의 이름·위치를 확인',
                relation: '실시간 전용 모델 인스턴스로 Pose와 독립 갱신하고 상황 위험도에 근거를 보탭니다.',
            },
            {
                layer: '위험도 오케스트레이션',
                input: 'AI Weight Manager',
                rule: 'Behavior · Environment · Emotion 합계 100%로 위험도 결합',
                relation: '선택한 운영 모드에 맞춰 모델 실행 자원과 최종 표시 위험도를 함께 조정합니다.',
            },
            {
                layer: '최종 검증·출력',
                input: '근거 gate · 오탐 필터',
                rule: '움직임 근거, 가림, 정지 사물, 사람 여부를 마지막으로 확인',
                relation: '전체 영상 정밀 결과가 후보를 확정·해제하고 낙상 여부와 판단 근거를 출력합니다.',
            },
        ];
    }

    public fallContractVerificationText(): string {
        const v2 = this.rfFallV2ThresholdValues();
        const pipeline = this.rfPipelineThresholdValues();
        return [
            '[낙상 판별 런타임 계약 · 2026-07-14 코드 교차 확인]',
            '1) 선택: F1 자동 비교 없음. RF-Dual은 RF-Pipeline 13개 특성을 먼저 계산하고, registry의 RF-Pipeline 명시 선택이 없고 RF-Fall v2가 준비되면 65개 특성 결과로 대체합니다. v2 불가·실패 때만 선행 결과가 fallback으로 남습니다.',
            '2) 현재: RF 계열 override가 없어 기본 RF-Dual 판단기는 RF-Fall v2입니다. RF-Pipeline active는 v17 · 3,405건 · F1 98.33% · Recall 99.47%이며 이 수치는 라우팅 기준이 아닙니다.',
            `3) 판정선: v2 suspect ${this.thresholdPercent(v2.suspect)} · confirm ${this.thresholdPercent(v2.confirm)} · best_f1 ${this.thresholdPercent(v2.bestF1)} · high ${this.thresholdPercent(v2.high)} · RF-Dual 상태 확정선 75.0% · RF-Pipeline 기본선 ${this.thresholdPercent(pipeline.confirm)}.`,
            '4) RF-Dual 순서: 공유 YOLO 시계열 → 실시간 tail 연결 → RF-Pipeline 확률 → 조건부 RF-Fall v2 대체 → 근거 수(<3)·움직임 gate → XG-Posture → Occlusion-Aux 조건부 혼합 → 자세 arbitration/rescue/veto·표정 보조 → 정지 사물 필터 → 사람/사물 판정 필터 → 최종 응답.',
            '5) 3프레임 미만: RF 확률 계산 뒤 낙상 false·insufficient_data·점수 최대 10%로 억제합니다. 2프레임은 가속도·끝자세 근거가 성립하지 않아 큰 delta 단독 예외를 열지 않았습니다. gate 수는 현재 RF 검출 프레임이며 실시간 tail은 제외합니다.',
            '6) 직접 요청 감사: registry RF-Pipeline 선택은 RF-Dual 자세·필터 흐름을 유지합니다. bare model_type=rf-pipeline은 독립 runner가 필터를 계산하지 않지만 공개 분석 경계의 필터 증명 검사에서 400 fail-closed 됩니다. 일반 UI에는 없고 저장소의 오래된 E2E 한 곳만 이 키를 의도적으로 요청합니다.',
            '7) 필터 구분: static-object-filter와 pose-entity-filter는 별도 모듈·artifact인 순차 2단계입니다. static의 골격 비율은 정지 gate 안에서만 쓰이고, pose의 골격 품질은 15% 가중치라 골격 비율 단독 hard veto는 없습니다.',
            '8) 알려진 오류: 12프레임 고정 장비·고신뢰도 가장자리 장비 규칙과 seated collapse rescue를 실제 반례에 추가했습니다. 00015 C2는 86프레임·점수 0.3306 대 suspect 0.335의 경계 사례였으며 <3 gate 문제가 아니었습니다.',
            '9) 출처 위험: 현재 RF-Fall v2는 원본 유실 뒤 임시 호환 복구본입니다. 표시된 1,592건/F1 93.02%/Recall 95.40%는 과거 복구 메타데이터이지 로드 바이너리의 재검증 결과가 아닙니다. 303건 후보는 모두 10초·27개 이상 검출이며 두 반례와 짧은 청크를 포함하지 않습니다.',
            '10) RiskVector: RF-Dual 업로드·실시간·비동기 Shadow 결과에 fallai.risk-vector.v1 낙상 벡터를 연결했습니다. risk_score는 위험 강도, confidence는 프레임·검출·Pose·가림 기반 결과 신뢰도로 분리하며 환경 벡터도 최상위 risk_vectors 배열에 함께 제공합니다.',
            '저장소 Markdown은 공개 웹 문서가 아닙니다. 이 화면의 텍스트가 동일 계약의 서비스 내 직접 확인본입니다.',
        ].join('\n\n');
    }

    public fallRiskVectorRows(): any[] {
        return [
            { field: 'risk_score / risk_level', current: 'RF-Dual 사건 점수·운영 판정 단계', status: '연결 완료', gap: 'risk_vector의 위험 강도와 low/medium/high로 직접 내보냅니다.' },
            { field: 'confidence', current: '입력·근거 신뢰도', status: '연결 완료', gap: '위험 확률과 분리해 sensor_quality.score로 계산합니다.' },
            { field: 'sensor_quality', current: '프레임·사람 검출·Pose·가림 진단', status: '연결 완료', gap: 'fallai.sensor-quality.v1 공통 객체와 산식을 함께 제공합니다.' },
            { field: 'evidence', current: '판정·점수·근거·이벤트·억제·품질 경고', status: '연결 완료', gap: '유형과 원천을 가진 표준 evidence 객체 배열로 정규화합니다.' },
            { field: 'event_type / timestamp / location', current: '낙상 상태·UTC 생성 시각·요청 공간 식별자', status: '연결 완료', gap: '공간 값이 없으면 unknown과 input_source를 명시해 누락 없이 내보냅니다.' },
        ];
    }

    public fallRiskVectorIntroText(): string {
        return 'RF-Dual 분석 API는 낙상 risk_vector를 직접 내보냅니다. 최상위 risk_vectors에는 낙상 벡터와 같은 분석에서 생성된 환경 Agent 벡터가 함께 정규화됩니다.';
    }
}

export default PagePipelineComponent;